import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();

    // Validasi sederhana (contoh user: admin, password: 1234)
    if ((user === "user" && password === "stimberindo") || (user === "sales" && password === "c3rtified")) {
      const expiresIn = 50400 * 1000; // Contoh: 1 jam = 3600 dalam milidetik jadi 3600*1000
      const expiryTime = Date.now() + expiresIn;
      localStorage.setItem("expiryTimeCertificate", expiryTime.toString());
      localStorage.setItem("isLoggedIn", "true");
      navigate("/home");
    } else {
      setError("Username atau password salah");
    }
  };

  return (
    <>
      <header className="masthead p-3" style={{ backgroundImage: "url('/assets/img/lok-bg.jpg')", height: "100vh" }}>
        <div className="container position-relative px-4 px-lg-5">
          <div className="row gx-4 gx-lg-5 justify-content-center">
            <div className="col-sm-10 col-md-10 col-lg-6 col-xl-6">
              <div className="card shadow-lg border-0 rounded mt-5">
                <div className="card-header">
                  <h3 className="text-center text-uppercase font-weight-light my-4">Login</h3>
                </div>
                <div className="card-body">
                  <form onSubmit={handleLogin}>
                    <div className="form-floating mb-3">
                      <input className="form-control" type="text" placeholder="User" value={user} onChange={(e) => setUser(e.target.value)} />
                      <label htmlFor="inputUser">User</label>
                    </div>
                    <div className="form-floating mb-3">
                      <input className="form-control" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                      <label htmlFor="inputPassword">Password</label>
                    </div>
                    {error && <p className="text-danger">{error}</p>}
                    <div className="d-flex align-items-center justify-content-end mt-4 mb-0">
                      <button className="btn btn-primary rounded" type="submit">
                        Login
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default LoginPage;
